import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * 自动执行
 * @param {Function} gen 
 * @returns 
 */
export var run = function run(gen) {
  var ctx = this;
  return new Promise(function (resolve, reject) {
    if (typeof gen === 'function') {
      gen = gen.call(ctx);
    } // 默认执行一次


    onFulfilled(null); // 成功回调方法

    function onFulfilled(res) {
      var ret;

      try {
        ret = gen.next(res);
      } catch (e) {
        return reject(e);
      }

      !ctx.isStop && next(ret);
    } // 失败回调方法


    function onRejected(err) {
      var ret;

      try {
        ret = gen["throw"](err);
      } catch (e) {
        return reject(e);
      }

      !ctx.isStop && next(ret);
    }

    function next(ret) {
      if (ret.done) return resolve(ret.value); // 如果ret不是promise
      // 那么自动返回一个promise

      if (ret.value.then) {
        return ret.value.then(onFulfilled, onRejected);
      }

      return Promise.resolve(ret.value);
    }
  });
};

var Poll = /*#__PURE__*/function () {
  // 已经轮训的次数
  // 是否停止
  // 回调执行方法
  // 策略方法
  function Poll(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    this.count = 0;
    this.isStop = false;
    this.callback = null;
    this.strategies = {
      'fixed-interval': function fixedInterval() {
        return _this.interval;
      },
      'linear-backoff': function linearBackoff() {
        _this.start + _this.increment * _this.count;
      },
      'exponential-backoff': function exponentialBackoff() {
        return Math.min(_this.max, Math.round(Math.random() * (Math.pow(2, _this.count) * 1000 - _this.min) + _this.min));
      }
    };
    // 策略类型
    this.type = options.type || 'fixed-interval'; // 静止策略间隔时间

    this.interval = options.interval || 1000; // 线性策略开始时间

    this.start = options.start || 0; // 线性策略增加时间

    this.incremnet = options.incremnet || 1000; // 指数策略最大值

    this.max = options.max || 30000; // 指数策略最小值

    this.min = options.min || 1000; // 策略时间计算方法

    this.getNextInterval = this.strategies[this.type];
  }
  /**
   * 延迟执行
   * @returns Promise
   */


  var _proto = Poll.prototype;

  _proto.delay = function delay() {
    var _this2 = this;

    return new Promise(function (resolve) {
      setTimeout(function () {
        // 进行下一个轮训
        _this2.count += 1;
        resolve(_this2.count);
      }, _this2.getNextInterval());
    });
  };

  _proto.exceute = function exceute(func) {
    // 上下文
    var context = this; // 回调

    this.callback = func; // 重新设置为非停止状态

    this.isStop = false; // 自动无限执行

    return run.call(this, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!true) {
                _context.next = 9;
                break;
              }

              _context.next = 3;
              return context.delay().then(function () {
                // 如果已经停止不执行回调请求
                !_this3.isStop && func(context);
              });

            case 3:
              if (!context.isStop) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return false;

            case 6:
              return _context.abrupt("break", 9);

            case 7:
              _context.next = 0;
              break;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })).then(function (res) {
      return res;
    });
  }
  /**
   * 重新启动轮询
   * @param {Function} func 
   */
  ;

  _proto.restart = function restart(func) {
    // 重新执行
    this.exceute(func || this.callback);
  }
  /**
   * 停止轮询
   */
  ;

  _proto.stop = function stop() {
    this.isStop = true;
  };

  return Poll;
}();

export { Poll as default };